import { Chip, Tooltip } from '@mui/material';
import { CheckCircle, ErrorOutline } from '@mui/icons-material';
import {
  TAX_EXEMPT_META,
  TAX_EXEMPT_STATUS,
  einStatusChipSx,
  getTaxExemptStatus,
} from 'src/utils/einStatus';

// Whether a donation to this recipient can be a tax write-off. Pass the org
// row, or a `status` already computed with getTaxExemptStatus (picker items
// carry it); renders nothing when the status is null.
export default function TaxExemptBadge({
  org,
  status: statusProp,
  compact = true,
  sx,
}) {
  const status =
    statusProp === undefined ? getTaxExemptStatus(org) : statusProp;
  if (!status) return null;

  const { color, label, tooltip } = TAX_EXEMPT_META[status];
  const Icon =
    status === TAX_EXEMPT_STATUS.VERIFIED ? CheckCircle : ErrorOutline;

  return (
    <Tooltip title={tooltip}>
      <Chip
        size="small"
        label={label}
        icon={<Icon style={{ color, fontSize: compact ? 14 : 16 }} />}
        data-testid={`tax-exempt-badge-${status}`}
        sx={{ ...einStatusChipSx(color, { compact }), ...sx }}
      />
    </Tooltip>
  );
}
